import React, { useMemo } from 'react';
import type { TaskTemplateRecord, TemplatePhase } from './templateManagementService';

interface TemplateDetailStatutesProps {
  template: TaskTemplateRecord;
  phases: TemplatePhase[];
}

const TemplateDetailStatutes: React.FC<TemplateDetailStatutesProps> = ({ template, phases }) => {
  const references = useMemo(() => {
    const set = new Set<string>();

    for (const reference of template.statutory_references || []) {
      if (reference?.trim()) set.add(reference.trim());
    }

    for (const phase of phases) {
      for (const task of phase.tasks) {
        if (task.mandate_reference?.trim()) set.add(task.mandate_reference.trim());
        if (task.statutory_deadline?.reference?.trim()) set.add(task.statutory_deadline.reference.trim());
      }
    }

    return Array.from(set);
  }, [phases, template.statutory_references]);

  if (references.length === 0) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">No statutory references are currently attached.</p>;
  }

  return (
    <ul className="space-y-2">
      {references.map((reference) => (
        <li key={reference} className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200">
          {reference}
        </li>
      ))}
    </ul>
  );
};

export default TemplateDetailStatutes;

